export default __webpack_public_path__ + "static/media/prod-img-10.463a5fb6.webp";